import React, { useCallback, useEffect, useState } from 'react'
import { CarouselButtons, CarouselContainer, SelectedFiltersWrapper } from '../pill/pill.styles'
import { ChevronLeft, ChevronRight } from '../icons/icons'
import { RenderPills } from './render-pills'
import { useObserveElementWidth } from '../../hooks/use-observe-element-width-hook'
import { PILLS_CONTAINER_ID } from '../../constants/ids'
import { FacetSuggestionPills } from '../pill/facet-suggestion-pills'
import { FilterPillsMobileProps } from './filter-pills-mobile'

export const FilterPillsDesktop = ({ filterPillLength, isFilterSelected }: FilterPillsMobileProps) => {
    const { width, ref } = useObserveElementWidth<HTMLDivElement>()

    const [hideRightArrow, setHideRightArrow] = useState(false)
    const [exceedsWidth, setExceedsWidth] = useState(false)
    const [carouselSteps, setCarouselSteps] = useState(0)

    useEffect(() => {
        if (ref.current) {
            const entireWidth = ref.current.scrollWidth
            const visibleWidth = ref.current.clientWidth
            const isScrollable = entireWidth !== visibleWidth
            if (isScrollable) {
                setExceedsWidth(true)
            } else {
                setExceedsWidth(false)
                setCarouselSteps(0)
            }
        }
    }, [width, filterPillLength, ref, exceedsWidth])

    const handleScroll = useCallback(() => {
        if (!ref.current) return
        const { scrollLeft, clientWidth: visibleWidth, scrollWidth: entireWidth } = ref.current

        // check if scrolled to the rightmost position
        setHideRightArrow(scrollLeft + visibleWidth >= entireWidth - 36)

        // check if scrolled to the leftmost position
        if (scrollLeft === 0) {
            setCarouselSteps(0)
        }
    }, [ref])

    const clickRight = useCallback(() => {
        if (ref.current) {
            const scrollAmount = ref.current.clientWidth * 0.75
            ref.current.scrollBy({ left: scrollAmount, behavior: 'auto' })
            setCarouselSteps((prevState) => prevState + 1)
        }
    }, [ref])

    const clickLeft = useCallback(() => {
        if (ref.current) {
            const scrollAmount = ref.current.clientWidth * 0.75
            const entireWidth = ref.current.scrollWidth
            // condition ensures that carousel will return to the left most point when the carouselSteps is 0
            if (carouselSteps === 1) {
                ref.current.scrollBy({ left: -entireWidth, behavior: 'auto' })
                setCarouselSteps((prevState) => (prevState -= 1))
                setHideRightArrow(false)
            } else {
                ref.current.scrollBy({ left: -scrollAmount, behavior: 'auto' })
                setCarouselSteps((prevState) => prevState - 1)
                setHideRightArrow(false)
            }
        }
    }, [ref, carouselSteps])

    return (
        <>
            <h1 className="visuallyhidden">Search Filters</h1>
            {carouselSteps > 0 && exceedsWidth ? (
                <CarouselContainer>
                    <CarouselButtons onClick={clickLeft} id="left-click">
                        <ChevronLeft name="Toggle filters left" size="medium" />
                    </CarouselButtons>
                </CarouselContainer>
            ) : null}
            <SelectedFiltersWrapper
                ref={ref}
                onScroll={handleScroll}
                data-testid={PILLS_CONTAINER_ID}
                id={PILLS_CONTAINER_ID}
            >
                <RenderPills isFilterSelected={isFilterSelected} />
                <FacetSuggestionPills />
            </SelectedFiltersWrapper>
            {exceedsWidth && !hideRightArrow ? (
                <CarouselContainer rightSide>
                    <CarouselButtons onClick={clickRight} id="right-click">
                        <ChevronRight name="Toggle filters right" size="medium" />
                    </CarouselButtons>
                </CarouselContainer>
            ) : null}
        </>
    )
}
